/**
 * Fetcher is a teeny wrapper around fetch
 */
import fetch from 'whatwg-fetch'; // eslint-disable-line no-unused-vars

function checkRawStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    let err = new Error(response.statusText);
    err.response = response;
    throw err;
  }
}

export function fetchHtml(endpoint) {
  return window
    .fetch(endpoint, {
      method: 'get'
    })
    .then(checkRawStatus)
    .then(resp => resp.text());
}

export function fetchJson(endpoint) {
  return window
    .fetch(endpoint, {
      method: 'get',
      mode: 'cors'
    })
    .then(checkRawStatus)
    .then(resp => resp.json());
}

export default {
  fetchHtml,
  fetchJson
};



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/fetcher.js